import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"

const Container = styled.section`
  position: relative;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const List = styled.div`
  height: auto;
  width: 20vw;
  //position: absolute;
  @media only screen and (max-width: 768px) {
    font-size: 5rem;
  }
`
const ImgCont = styled.div`
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  margin: 10px;
  justify-content: center;
  position: relative;
  display: flex;
  width: 100px;
  @media (min-width: 200px) and (max-width: 768px) {
    flex-direction: column;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 100%;
  }
`
const CourseBlock = styled.div`
  margin: 20px;
  display: flex;
  border-radius: 15px;
  background: var(--dark-card);
`

const ContentWrapper = styled.div`
  padding: 5px;
  min-width: 50%;
  max-width: 50%;
  height: 100%;
  color: var(--text-gray);
  align-self: center;
`

const CourseTitle = styled.div`
  color: white;
  font-family: var(--main-font);
  font-size: 1.1em;
`

// const ReadMore = styled.div`
//   padding: 10px;
//   background: blue;
//   align-self: center;
// `

export const ReadMore = styled(Link)`
  display: flex;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  align-self: center;
  margin: 15px;
  padding: 2% 5%;
  color: var(--text-gray);
  height: min-content;
  background-color: var(--secondary-color);
  border: 0;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  border-radius: 10px;
  &:hover {
    box-shadow: 0 15px 15px rgba(0, 0, 0, 0.16);
    transform: translate(0, -3px);
  }
  @media (min-width: 200px) and (max-width: 600px) {
    max-width: 70%;
    font-size: 2.6vw;
  }
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    max-width: 70%;
    font-size: 2.6vw;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    font-size: 0.7rem;
  }
  @media (min-width: 901px) and (max-width: 1100px) {
    font-size: 0.7rem;
  }
  @media (min-width: 1101px) and (max-width: 3000px) {
    font-size: 0.7rem;
  }
`

export const SideBlogList = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlog(limit: 5) {
        edges {
          node {
            id
            datePublished(formatString: "MMMM Do YYYY")
            image {
              gatsbyImageData(width: 400)
              title
            }
            title
            slug
          }
        }
      }
    }
  `)

  return (
    <Container>
      <List>
        <h2 style={{ paddingLeft: 20 }}>Latest blogs </h2>
        {data.allContentfulBlog.edges.map(edge => {
          const image = getImage(edge.node.image?.gatsbyImageData)
          console.log("BlogList Image", image)
          return (
            <CourseBlock key={edge.node.id}>
              <ImgCont>
                {edge.node.image && (
                  <GatsbyImage
                    image={image}
                    alt={data.allContentfulBlog.title}
                  />
                )}
              </ImgCont>
              <ContentWrapper>
                <CourseTitle>{edge.node.title}</CourseTitle>
              </ContentWrapper>
              <ReadMore to={`/blogs/${edge.node.slug}`}>READ</ReadMore>
            </CourseBlock>
          )
        })}
      </List>
    </Container>
  )
}

export default SideBlogList
